// extracted by mini-css-extract-plugin
export default {"service-notice":"LooKnZf3"};